import React, { useState, useImperativeHandle } from "react";
import ModalView from '@/components/modal-view'
import styled from "styled-components";
import ArriveBg from '../imgs/arrive-icon@2x.png';
import ArriveClose from '../imgs/arrive-close@2x.png'

const ArriveModal = React.forwardRef((_, ref) => {
  const [showModal, setShowModal] = useState(false);
  const [rawData, setRawData] = useState({});

  useImperativeHandle(ref, () => {
    return {
      show: (data) => {
        setRawData(data);
        setShowModal(true);
      },
    }
  });

  return (
    <ModalView
      visible={showModal}
      onClose={() => setShowModal(false)}
      content={
        <ModalWrap>
          <div className="arrive-img">
            <div className="bonus-title">恭喜你获得新的邀请好友奖励</div>
            <div className="bonus-value">当前账户余额：{rawData.withdrawableBonus}元</div>
            <div className="money-wrap">
              <span className="money-value">{rawData.newArriveBonus}</span>
              <span className="money-unit">元</span>
            </div>
            <div className="bonus-text">新增奖励金额</div>
            <div className="confirm-btn">
              <div onClick={() => setShowModal(false)} className="confirm-text">开心收下</div>
            </div>
          </div>
          <div className="arrive-close-wrap">
            <img onClick={() => setShowModal(false)} alt="" src={ArriveClose} className="arrive-close"/>
          </div>
        </ModalWrap>
      }
    />
  )
})

const ModalWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #222222;
  .arrive-img {
    width: 321px;
    height: 505px;
    background-image: url(${ArriveBg});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding-top: 221px;
    .bonus-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 18px;
    }
    .bonus-value {
      font-size: 16px;
      font-weight: 500;
      color: #7A7A7A;
      line-height: 16px;
      margin-top: 15px;
    }
    .money-wrap {
      margin-top: 45px;
    }
    .money-value {
      font-size: 56px;
      font-weight: bold;
      line-height: 56px;
    }
    .money-unit {
      font-size: 27px;
      font-weight: 500;
      line-height: 27px;
      margin-left: 7px;
      padding-bottom: 5px;
    }
    .bonus-text, .money-wrap {
      color: transparent;
      background-image: linear-gradient(-90deg, #FB4C3D 0%, #FFA200 99%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .bonus-text {
      font-size: 17px;
      font-weight: 500;
      line-height: 17px;
      margin-top: 11px;
    }
    .confirm-btn {
      display: flex;
      justify-content: center;
      margin-top: 38px;
    }
    .confirm-text {
      width: 173px;
      height: 41px;
      background: linear-gradient(-90deg, #FB4C3D 0%, #FFA200 99%);
      border-radius: 21px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-weight: 400;
      color: #FFFFFF;
      letter-spacing: 1px;
    }
  }

  .arrive-close-wrap {
    margin-top: 21px;
    display: flex;
    justify-content: center;
    .arrive-close {
      width: 33px;
      height: 33px;
    }
  }
`

export default React.memo(ArriveModal);




// WEBPACK FOOTER //
// ./src/views/activity_42/components/arrive-modal.js